import React, { Component } from "react";
import SvgIcon from 'react-icons-kit';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';

import LabelForm from '../../../components/LabelForm';
import SelectForm from '../../../components/SelectForm';
import InputForm from '../../../components/InputForm';
import { functionalCriterial } from "../../../libs/services";

class LabSections extends Component{
    constructor(props){
        super(props);


        this.state = {
            show_numeric:false,
            show_numeric_value:{},
            lab_show_num_value:{},
            edit_numerical_lab_results:false
        };
    }

    async componentDidMount(){
        this.props.onRef(this);
        
        var response = await functionalCriterial('LAB_SHOW_NUM_VALUE');
		if(response !== undefined){
			this.setState({
				lab_show_num_value: response
			});
		}

        var user_task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));

		user_task.forEach((user)=>{
			if(user !== undefined){
				if(user === 'EDIT_NUMERICAL_LAB_RESULTS'){
					this.setState({edit_numerical_lab_results:true});
				}
			}
		});
    }


    render(){
        return(
            <div className="col-xs-12 form-group">
                {(this.state.lab_show_num_value.value === 'YES' && this.state.edit_numerical_lab_results) &&
					<div className='col-xs-12 form-group'>
						<input type="checkbox" name="show_numeric" id="show_numeric" 
							value={this.state.show_numeric} checked={this.state.show_numeric} 
							onChange={(e)=>this.setState({show_numeric: e.target.checked})}
						/> Editar valores numericos
					</div>
				}
                {this.props.sections.map((section, i)=>
                    <fieldset key={i} className="col-xs-12 form-group">
                        <legend>{section.Name}</legend>
                        <div className="col-xs-12 col-sm-8" style={{marginTop:10}}>
                            {section.ShowContent ?
                                section.TestList.map((test, j)=>
                                    <div className="col-xs-12 form-group no-padding" key={j}>
                                        <div className="col-xs-12 col-sm-6">
                                            <LabelForm text={test.Name} />
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            {test.Type === 'CUALITATIVO' ?
                                                <SelectForm 
                                                    id={test.ID}
                                                    value={test.value}
                                                    options={test.AcceptedValues}
                                                    variables={{section:i, test:j, type:'combo'}}
                                                    handleChange={this.props.changeResultValue}
                                                    class={test.accepted ? '' : ' error'}
                                                    disabled={section.CanModify ? test.validated : true }
                                                />
                                            :
                                                <InputForm 
                                                    id={test.ID}
                                                    value={test.value}
                                                    variables={{section:i, test:j, type:'text'}}
                                                    handleChange={this.props.changeResultValue}   
                                                    disabled={section.CanModify ? test.validated : true }
                                                />
                                            }
                                        </div>
                                        {this.state.lab_show_num_value.value === 'YES' ?
                                            (test.ShowNumericValue && 
                                                <div className="col-xs-12 col-sm-1">
                                                    <InputForm 
                                                        id={'numeric_'+test.ID}
                                                        value={test.numeric_value}
                                                        variables={{section:i, test:j, type:'numeric'}}
                                                        handleChange={this.props.changeResultValue}
                                                        type="numeric"
                                                        disabled={section.CanModify ?
                                                            test.Result !== null ? 
                                                                true
                                                            : !this.state.show_numeric
                                                        :true}
                                                    />
                                                </div>
                                            )
                                        :null}

                                        {test.validated &&
                                                <div className="col-xs-12 col-sm-1">
                                                    <div style={{color:"green", width:"33.3%"}}>
                                                        <SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
                                                    </div>
                                                </div>

                                        }
                                    </div>
                                )
                            :
                                <h3 style={{color:"red", textAlign:'center'}}>{section.ContentMessage}</h3>
                            }
                        </div>
                    </fieldset>
                )}
            </div>
        )
    }
}

export default LabSections;